import { Injectable } from '@angular/core';

export interface LoadRequest<OutputType> {
  id: string;
  promise: Promise<OutputType>;
}

export interface ScriptDefinition {
  id: string;
  src?: string;
  body?: string;
}

declare let document: any;

@Injectable({ providedIn: 'root' })
export class ScriptManagementService {
  private loadRequests: Record<string, LoadRequest<any>> = {};

  load<OutputType = any>({ src, body, id }: ScriptDefinition): Promise<OutputType> {
    const existingRequest = this.loadRequests[id];
    if (existingRequest) {
      return Promise.resolve(existingRequest.promise);
    }
    this.loadRequests[id] = {
      id,
      promise: new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.onerror = (error: any) => reject(error);
        if (src) {
          script.onload = (output: OutputType) => resolve(output);
          script.src = src;
        }
        if (body) {
          script.innerHTML = body;
        }
        document.getElementsByTagName('head')[0].appendChild(script);
        if (body && !src) {
          resolve(null);
        }
      }),
    };
    return Promise.resolve(this.loadRequests[id].promise);
  }
}
